import { createRouter, createWebHistory } from 'vue-router'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '@/firebase'
import { anaLog } from '@/utils'
import axios from 'axios'
import { getCookie, setCookie } from '@/utils'
import { BaseUrl } from '@/config'



const routes = [
  {
    path: '/',
    name: 'landing',
    nav: {
      title: 'Home',
      icon: 'fa fa-home',
    },
    component: () => import(/* webpackChunkName: "about" */ '@/view/LandingView.vue')
  },
  {
    path: '/about',
    name: 'about',
    nav: {
      title: 'About',
      icon: 'fa fa-info-circle',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../view/AboutView.vue')
  },

  {
    path: '/blogs',
    name: 'Blogs',
    nav: {
      title: 'Blogs',
      icon: 'fa fa-newspaper',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../view/BlogView.vue')
  },
  
  {
    path: '/blogs/:id',
    name: 'blogs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../view/BlogView.vue')
  },
  {
    path: '/blog/:id',
    name: 'blog',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../view/BlogView.vue')
  },
  {
    path: '/auth/:display',
    name: 'auth',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/view/auth/AuthView.vue')
  },
  {
    path: '/projects',
    name: 'Projects',
    nav: {
      title: 'Projects',
      icon: 'fa fa-paperclip',
    },
    meta: {
      parent: 'Company',
      authRequired: true,
      claims: [['admin'], ['company_owner'], ['company_admin']],
    },
    component: () => import(/* webpackChunkName: "about" */ '@/apps/projects/ProjectsView.vue')
  },
  {
    path: '/quotebuilder/v3',
    name: 'quotebuilderv3',
    component: () => import(/* webpackChunkName: "about" */ '@/apps/quotebuilder/EstimateBuilder.vue'),
    meta: {
      authRequired: false,
      claims: [],
      always_show_public_route: false,
      public: false,
    },
    nav: {
      title: 'Quotebuilder',
      icon: 'fa fa-calculator',
    },
  },
  {
    path: '/project/:projectId',
    name: 'Project',
    component: () => import(/* webpackChunkName: "about" */ '@/apps/projects/ProjectView.vue')
  },
  {
    path: '/admin/blogs',
    name: 'adminBlogs',
    nav: {
      parent: 'Admin',
      title: 'Blogs',
      icon: 'fa fa-newspaper',
    },
    meta: {
      authRequired: true,
      claims: [['admin'], ['blog_editor']],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../view/admin/BlogsView.vue')
  },
  // {
  //   path: '/admin/proposal-builder',
  //   name: 'adminProposalBuilder',
  //   nav: {
  //     parent: 'Admin',
  //     title: 'Proposal Builder',
  //     icon: 'fa fa-calculator',
  //   },
  //   meta: {
  //     authRequired: true,
  //     claims: [['admin']],
  //   },
  //   component: () => import(/* webpackChunkName: "about" */ '@/apps/proposal-builder/ProposalBuilder.vue')
  // },
  {
    path: '/admin/users',
    name: 'adminUsers',
    nav: {
      parent: 'Admin',
      title: 'Users',
      icon: 'fa fa-users',
    },
    meta: {
      parent: 'Admin',
      authRequired: true,
      claims: [['admin']],
    },
    component: () => import(/* webpackChunkName: "about" */ '../view/admin/users/UsersView.vue')
  },
  {
    path: '/company/:company_id/dashboard',
    name: 'dashboard',
    meta: {
      authRequired: true,
      parent: 'Company',
      matchClaim: 'company_id',
      claims: [],
    },
    nav: {
      title: 'Dashboard',
      icon: 'fa fa-tachometer-alt',
      parent: 'Company',
      claims: [],
    },
    component: () => import(/* webpackChunkName: "about" */ '@/apps/dashboardsv2/DashboardIndex.vue')
  },
  {
    path: '/quotebuilder/v2',
    name: 'quotebuilderv2',
    nav: {
      title: 'Quote Builder',
      icon: 'fa fa-calculator',
    },
    meta: {
      authRequired: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/apps/quotebuilder/EstimateBuilder.vue')
  },
  {
    path: '/support/companies',
    name: 'CompanySupport',
    nav: {
      parent: 'Support',
      title: 'Companies',
      icon: 'fa fa-building',
    },
    meta: {
      parent: 'Support',
      authRequired: true,
      claims: [['admin']],
    },
    component: () => import(/* webpackChunkName: "about" */ '@/view/admin/support/CompaniesOverview.vue')
  },
  // {
  //   path: '/company/:company_id/proposal-builder',
  //   name: 'companyProposalBuilder',
  //   nav: {
  //     parent: 'Company',
  //     title: 'Proposal Builder',
  //     icon: 'fa fa-calculator',
  //   },
  //   meta: {
  //     showNav: false,
  //     authRequired: true,
  //     claims: [['admin'], ['proposal_builder']],
  //     matchClaim: 'company_id',
  //     // companyType: "solar",
  //   },
  //   component: () => import(/* webpackChunkName: "about" */ '@/apps/proposal-builder/ProposalBuilder.vue')
  // },
  {
    path: '/company/:company_id/manage',
    name: 'CompanyManage',
    nav: {
      parent: 'Company',
      title: 'Manage',
      icon: 'fa fa-cogs',
    },
    meta: {
      parent: 'Company',
      authRequired: true,
      claims: [['admin'], ['company_admin'], ['company_owner']],
      matchClaim: 'company_id',
    },
    component: () => import(/* webpackChunkName: "company" */ '@/apps/company/Company.vue')
  },
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    // if contains hash, scroll to hash
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    // always scroll to top
    return { top: 0 }
  },
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// import from uuid to create new cookie
import { v4 as uuidv4 } from 'uuid';

router.beforeEach(async(to, from, next) => {
  const authRequired = to.matched.some(record => record.meta.authRequired);
  const permissions = to.matched.some(record => record.meta.permissions);
  const authLinkAccepted = to.matched.some(record => record.meta.authLinkAccepted);
  const hasClaims = to.matched.some(record => record.meta.claims) || to.matched.some(record => record.meta.matchClaim);
  const matchClaim = to.matched.some(record => record.meta.matchClaim);
  const companyType = to.matched.some(record => record.meta.companyType);
  
  // check if cookie exists
  if (getCookie('SelfgensAnalytics') == null) {
    // if not, create cookie
    setCookie('SelfgensAnalytics', uuidv4())
  }

  anaLog('route', {
    to: to.path,
    from: from.path,
  })
  if (authRequired == false ) {
    next();
    // window.scrollTo(0, 0)
  } else {
    const p = new Promise((resolve, reject) => {
      
      onAuthStateChanged(auth,async (user) => {
        if (user) {
          // User is signed in, see docs for a list of available properties
          // https://firebase.google.com/docs/reference/js/firebase.User
          // const uid = user.uid;
          // ...

          if(hasClaims || matchClaim){
            let claims = to.meta.claims;
            try {
            await user.getIdToken()
            let idTokenResult = await user.getIdTokenResult()
              // Confirm the user is an Admin.
              if (companyType) {
                if (idTokenResult.claims['company_type'] !== to.meta.companyType) {
                  next('/')
                  reject()
                  return
                }
              }
              if (matchClaim) {
                let claim = to.meta.matchClaim
                let claimValue = idTokenResult.claims[claim]
                let claimMatch = to.params[claim]

                if (claimMatch !== claimValue){
                  if (idTokenResult.claims['admin'] === true) {
                    next()
                    resolve()
                    return
                  }
                  // replace with correct param
                  let nextPath = to.path.replace(claimMatch, claimValue)
                  next(nextPath)
                  // reject()
                  resolve()
                  return
                
                }
              }

              let valid = true;
              for(let opts of claims){
                valid = true;
                for(let claim of opts) if(!idTokenResult.claims[claim])valid = false;
                if(valid){
                  break;
                }
              }
              if(valid === true){
                next()
                resolve()
                return;
              }

              if (authLinkAccepted) {
                let phone = to.params.phone
                let hash = to.query.hash

                if (phone == undefined || hash == undefined) {
                  next('/')
                  reject()
                }

                axios.post(BaseUrl+'/sunny/validatequoteslink', {phone, hash})
                  .then(res => {
                    next()
                    resolve()
                  })
                  .catch(err => {
                    next('/')
                    reject()
                  })
              }
              next('/')
              reject()
              return
            }catch(error) {
              next('/')
              reject()
              return
            };
          }

          next()
          
          resolve()
          
        } else if (authLinkAccepted) {
          let phone = to.params.phone
          let hash = to.query.hash

          if (phone == undefined || hash == undefined) {
            next('/')
            reject()
          }

          axios.post(BaseUrl+'/sunny/validatequoteslink', {phone, hash})
            .then(res => {
              next()
              resolve()
            })
            .catch(err => {
              next('/')
              reject()
            })
            
          
        } else {
          next('/auth/login')
          
          reject()
        }
      });
    })
    await p;
  }
})

export default router
